import { defineComponent as _defineComponent } from 'vue'
import { watch, computed } from 'vue';

// @ts-ignore
import CustomerFeaturesTasksDropdown from '@/components/Billing/BillingPlanCardSlotHandler/CustomerFeaturesTasksDropdown.vue';
// @ts-ignore
import TeamFeaturesVirtuallyUnlimitedToggle from '@/components/Billing/BillingPlanCardSlotHandler/TeamFeaturesVirtuallyUnlimitedToggle.vue';
import BillingService from '@/components/Billing/billing-service';
import { Plan, SelectOption } from '@/components/Billing/billing-types';

export default /*#__PURE__*/_defineComponent({
  __name: 'BillingPlanCardSlotHandler',
  props: {
    plan: null,
    isSelected: { type: Boolean },
    selectedTab: null,
    disableToggle: { type: Boolean },
    selectOptions: null,
    selectedCustomerFeatureTasksAmount: null
  },
  emits: ["update-selected-tab", "update-selected-option-value", "update-customer-features-tasks-quantity"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'update-selected-tab', tabIndex: number): void;
	(e: 'update-selected-option-value', selectedCustomerFeatureTasksAmount: number): void;
	(e: 'update-customer-features-tasks-quantity', customerFeaturesTasksQuantity: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	plan: Plan;
	isSelected: boolean;
	selectedTab: number;
	disableToggle?: boolean;
	selectOptions?: SelectOption[];
	selectedCustomerFeatureTasksAmount?: number;
}



const isSelected = computed(() => props.isSelected);
const featureTypeNoun = computed(() => (isTeamFeaturesPlan.value ? 'team' : 'customer'));
const isPaidPlan = computed(() => BillingService.isPaidPlan(props.plan));
const isFreePlan = computed(() => BillingService.isFreePlan(props.plan));
const isEnterprisePlan = computed(() => BillingService.isEnterprisePlan(props.plan));
const isTeamFeaturesPlan = computed(() => BillingService.isTeamFeaturesPlan(props.plan));
const isCustomerFeaturesPlan = computed(() => BillingService.isCustomerFeaturesPlan(props.plan));
const displayNumOfTasksText = computed(() => {
	const numOfTasks = isEnterprisePlan.value ? 'Custom' : BillingService.getPlanUsageLimit(props.plan);
	if (isTeamFeaturesPlan.value && isFreePlan.value) {
		return `${numOfTasks} tasks`;
	}
	const sentenceSuffix = `${featureTypeNoun.value} feature tasks`;
	return `${numOfTasks} ${sentenceSuffix}${isEnterprisePlan.value ? '' : ' / month'}`;
});
watch(isSelected, (newValue) => {
	if (newValue && isCustomerFeaturesPlan.value && isFreePlan.value) {
		emit('update-customer-features-tasks-quantity', BillingService.getPlanUsageLimit(props.plan));
	}
});

return { __sfc: true,emit, props, isSelected, featureTypeNoun, isPaidPlan, isFreePlan, isEnterprisePlan, isTeamFeaturesPlan, isCustomerFeaturesPlan, displayNumOfTasksText, CustomerFeaturesTasksDropdown, TeamFeaturesVirtuallyUnlimitedToggle }
}

})